<script setup lang="ts">
import { computed } from "vue";

interface Session {
  id: string;
  user_agent: string;
  ip_address: string;
  created_at: string;
}

interface Props {
  session: Session;
  currentSessionId?: string;
  title?: string;
  dateLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  currentSessionId: "",
  title: "",
  dateLabel: "Since",
});

const isCurrent = computed(() => props.currentSessionId === props.session.id);
const displayTitle = computed(() => props.title || props.session.user_agent || "Session");
const formattedDate = computed(() =>
  new Date(props.session.created_at).toLocaleString(),
);
</script>

<template>
  <article class="rounded-xl border p-4">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <p class="text-sm font-medium">
          {{ displayTitle }}
          <span
            v-if="isCurrent"
            class="ml-2 rounded bg-muted px-1.5 py-0.5 text-[10px]"
            >Current</span
          >
        </p>
        <p class="mt-1 text-xs text-muted-foreground">
          IP: {{ session.ip_address || "-" }}
        </p>
        <p class="text-xs text-muted-foreground">
          {{ dateLabel }}: {{ formattedDate }}
        </p>
      </div>

      <slot name="action" :is-current="isCurrent" />
    </div>
  </article>
</template>
